import 'react-tooltip/dist/react-tooltip.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useState, useEffect } from "react";
import { Row, Col, Container, Button, Modal, Form, Stack, Alert } from "react-bootstrap";
import { patchAccreditedStockPersonUser, postAccreditedStockPersonUser, reInviteAccreditedStockPersonUser } from '../../api/apiAccess';
import { StringIsNullUndefinedOrEmpty } from '../../utils/StringUtils';
import { Tooltip } from 'react-tooltip';
import { NumericValidationRules, parseNumericInput, isValidEmail, isValidMobile } from '../../utils/InputValidator';
import DateTimePicker from '../DateTimePicker';
import Swal from "../../utils/Swal";

const Accredited_Stockpersons_Add_Edit_Modal = ({ managementUser, showModal, setShowModal, onAdd }) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [headerText, setHeaderText] = useState("Add New Accredited Stockperson");
    const [successText, setSuccessText] = useState("");

    const [id, setID] = useState(null);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [mobilePhone, setMobilePhone] = useState("");
    const [accreditationNumber, setAccreditationNumber] = useState("");
    const [initialAccreditationDate, setInitialAccreditationDate] = useState(null);
    const [accreditationStatus, setAccreditationStatus] = useState(true);
    const [isActive, setIsActive] = useState(true);

    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const [validFirstName, setValidFirstName] = useState(true);
    const [validLastName, setValidLastName] = useState(true);
    const [validAccreditationNumber, setValidAccreditationNumber] = useState(true);
    const [validAccreditationDate, setValidAccreditationDate] = useState(true);
    const [validEmail, setValidEmail] = useState(true);
    const [validPhone, setValidPhone] = useState(true);

    const numericValidationRules = new NumericValidationRules({ allowLeadingZerosForWholeNumbers: true, allowNegative: false, allowDecimal: false });

    useEffect(() => {
        clearCurrentErrors();
        if (managementUser) { // edit
            setIsEditMode(true);
            setHeaderText("View/Edit Accredited Stockperson");
            setSuccessText("The accredited stockperson has been successfully updated.");

            setID(managementUser.id);
            setFirstName(managementUser.firstName);
            setLastName(managementUser.lastName);
            setAccreditationNumber(managementUser.accreditationNumber);

            if (managementUser.accreditationDateUTC) {
                // have to do this so we display exactly what the user enters otherwise automatic conversion takes place
                let lDateTimeParts = managementUser.accreditationDateUTC.split("T");
                
                let lDateParts = lDateTimeParts[0].split("-");
                let lDate = new Date(lDateParts[0], Number(lDateParts[1]) - 1, lDateParts[2]);
                setInitialAccreditationDate(lDate);
            }
            else {
                setInitialAccreditationDate(null);
            }

            setEmailAddress(managementUser.emailAddress);
            setMobilePhone(managementUser.phoneNumber);
            setIsActive(managementUser.isActive);
        }
        else { // add
            setIsEditMode(false);
            setHeaderText("Add New Accredited Stockperson");
            setSuccessText("The accredited stockperson has been added successfully.");

            setID(null);
            setFirstName("");
            setLastName("");
            setAccreditationNumber("");
            setInitialAccreditationDate(null);
            setEmailAddress("");
            setMobilePhone("");
            setIsActive(true);
        }
    }, [managementUser]);

    const clearCurrentErrors = () => {
        setShowSuccessMessage(false);
        setShowErrorMessage(false);
        setValidFirstName(true);
        setValidLastName(true);
        setValidEmail(true);
        setValidPhone(true);
        setValidAccreditationNumber(true);
        setValidAccreditationDate(true);
    }

    const save = () => {
        setShowErrorMessage(false);
        setShowSuccessMessage(false);
        setErrorMessage("");
        setValidFirstName(false);
        setValidLastName(false);
        setValidEmail(false);
        setValidPhone(false);

        const clearInputs = () => {
            setID(null);
            setFirstName("");
            setLastName("");
            setAccreditationNumber("");
            setInitialAccreditationDate(null);
            setEmailAddress("");
            setMobilePhone("");
            setIsActive(true);
        }

        const saveAndValidate = async () => {
            // validate
            let lValidFirstName = !StringIsNullUndefinedOrEmpty(firstName);
            let lValidLastName = !StringIsNullUndefinedOrEmpty(lastName);
            let lValidEmail = isValidEmail(emailAddress);
            let lValidPhoneNumber = isValidMobile(mobilePhone);
            let lValidAccreditationNumber = !StringIsNullUndefinedOrEmpty(accreditationNumber); //todo what is a valid value
            let lValidAccreditationDate = !StringIsNullUndefinedOrEmpty(initialAccreditationDate) && initialAccreditationDate <= new Date();

            setValidFirstName(lValidFirstName);
            setValidLastName(lValidLastName);
            setValidEmail(lValidEmail);
            setValidPhone(lValidPhoneNumber);
            setValidAccreditationNumber(lValidAccreditationNumber);
            setValidAccreditationDate(lValidAccreditationDate);

            if (lValidFirstName && lValidLastName && lValidEmail && lValidPhoneNumber && lValidAccreditationNumber && lValidAccreditationDate) {
                // save
                // have to do this so we save exactly what the user enters
                let lYear = initialAccreditationDate.getFullYear().toString();
                let lMonth = (initialAccreditationDate.getMonth() + 1).toString();
                let lDay = initialAccreditationDate.getDate().toString();

                if (lMonth.length === 1) {
                    lMonth = "0" + lMonth;
                }
                if (lDay.length === 1) {
                    lDay = "0" + lDay;
                }

                let lDate = lYear + "-" + lMonth + "-" + lDay + "T00:00:00Z";

                // parse any boolean values from string to boolean, otherwise we get a bad request when calling the api
                let lAccreditationStatus = JSON.parse(accreditationStatus);
                let lIsActive = JSON.parse(isActive);

                let lMode = "add new";
                if(isEditMode){
                    lMode = "edit";
                }

                let result; 

                if (isEditMode === true) {
                    result = await patchAccreditedStockPersonUser(id, firstName, lastName, emailAddress, mobilePhone, accreditationNumber, lDate, lAccreditationStatus, lIsActive);
                }
                else {
                    result = await postAccreditedStockPersonUser(firstName, lastName, emailAddress, mobilePhone, accreditationNumber, lDate, lAccreditationStatus, lIsActive);
                }

                if (result.status == 200) {
                    setShowSuccessMessage(true);
                    onAdd();

                    if (isEditMode === false) {
                        clearInputs();
                    }

                    setTimeout(() => {
                        setShowSuccessMessage(false);
                    }, 15000);
                }
                else if (result.status == 400) {
                    setShowErrorMessage(true);
                    if (result.data && typeof result.data === `string`) {
                        setErrorMessage(result.data);
                    }
                    else {
                        setErrorMessage(`Unable to ${lMode} accredited stockperson.`);
                    }
                }
                else {
                    setShowErrorMessage(true);
                    setErrorMessage(`Unable to ${lMode} accredited stockperson.`);
                }
            }
        }
        saveAndValidate();
    }

    const reinvite = async () => {
        let lYear = initialAccreditationDate.getFullYear().toString();
        let lMonth = (initialAccreditationDate.getMonth() + 1).toString();
        let lDay = initialAccreditationDate.getDate().toString();

        if (lMonth.length === 1) {
            lMonth = "0" + lMonth;
        }
        if (lDay.length === 1) {
            lDay = "0" + lDay;
        }

        let lDate = lYear + "-" + lMonth + "-" + lDay + "T00:00:00Z";
        let lAccreditationStatus = JSON.parse(accreditationStatus);
        let lIsActive = JSON.parse(isActive);
        
        let result = await reInviteAccreditedStockPersonUser(firstName, lastName, emailAddress, mobilePhone, accreditationNumber, lDate, lAccreditationStatus, lIsActive);

        if (result.status == 200) {
            Swal.Toast("Sent re-invite email successfully");
            setShowModal(false);
        }
        else if (result.status == 400) {
            setShowErrorMessage(true);
            if (result.data) {
                setErrorMessage(result.data);
            }
            else {
                setErrorMessage(`Unable to send invite email for edit accredited stockperson.`);
            }
        }
        else {
            setShowErrorMessage(true);
            setErrorMessage(`Unable to send invite email for edit accredited stockperson.`);
        }
    }

    return (
        <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{headerText}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row className="mb-3">
                        <Col>
                            <Stack>
                                <div className="darkblue field-label">First Name</div>
                                <Form.Group>
                                    <Form.Control
                                        id={`txtFirstName`}
                                        onChange={(e) => {
                                            setFirstName(e.target.value);
                                            setValidFirstName(true);
                                        }}
                                        value={firstName}
                                        isInvalid={validFirstName === false}
                                    />
                                    {
                                        validFirstName === false ?
                                            (<div className="validation-error-tooltip">
                                                <Tooltip
                                                    anchorSelect={`#txtFirstName`}
                                                    place="top"
                                                    variant="error"
                                                    content="A first name is required."
                                                />
                                            </div>
                                            ) : null
                                    }
                                </Form.Group>
                            </Stack>
                        </Col>
                        <Col>
                            <Stack>
                                <div className="darkblue field-label">Last Name</div>
                                <Form.Group>
                                    <Form.Control
                                        id={`txtLastName`}
                                        onChange={(e) => {
                                            setLastName(e.target.value);
                                            setValidLastName(true);
                                        }}
                                        value={lastName}
                                        isInvalid={validLastName === false}
                                    />
                                    {
                                        validLastName === false ?
                                            (<div className="validation-error-tooltip">
                                                <Tooltip
                                                    anchorSelect={`#txtLastName`}
                                                    place="top"
                                                    variant="error"
                                                    content="A last name is required."
                                                />
                                            </div>
                                            ) : null
                                    }
                                </Form.Group>
                            </Stack>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <Stack>
                                <div className="darkblue field-label">Email Address</div>
                                <Form.Group>
                                    <Form.Control
                                        id={`txtEmail`}
                                        onChange={(e) => {
                                            setEmailAddress(e.target.value);
                                            setValidEmail(true);
                                        }}
                                        value={emailAddress}
                                        isInvalid={validEmail === false}
                                    />
                                    {
                                        validEmail === false ?
                                            (<div className="validation-error-tooltip">
                                                <Tooltip
                                                    anchorSelect={`#txtEmail`}
                                                    place="top"
                                                    variant="error"
                                                    content="A valid email address is required."
                                                />
                                            </div>
                                            ) : null
                                    }
                                </Form.Group>
                            </Stack>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={6}>
                            <Stack>
                                <div className="darkblue field-label">Mobile Phone</div>
                                <Form.Group>
                                    <Form.Control
                                        id={`txtPhone`}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            parseNumericInput(e, numericValidationRules);
                                            setMobilePhone(e.target.value);
                                            setValidPhone(true);
                                        }}
                                        value={mobilePhone}
                                        isInvalid={validPhone === false}
                                    />
                                    {
                                        validPhone === false ?
                                            (<div className="validation-error-tooltip">
                                                <Tooltip
                                                    anchorSelect={`#txtPhone`}
                                                    place="top"
                                                    variant="error"
                                                    content="A valid mobile phone number is required."
                                                />
                                            </div>
                                            ) : null
                                    }
                                </Form.Group>
                            </Stack>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={6}>
                            <Stack>
                                <div className="darkblue field-label">Accredited Stockperson ID number</div>
                                <Form.Group>
                                    <Form.Control
                                        id={`txtAccreditationNumber`}
                                        onChange={(e) => {
                                            setAccreditationNumber(e.target.value);
                                            setValidAccreditationNumber(true);
                                        }}
                                        value={accreditationNumber}
                                        isInvalid={validAccreditationNumber === false}
                                    />
                                    {
                                        validAccreditationNumber === false ?
                                            (<div className="validation-error-tooltip">
                                                <Tooltip
                                                    anchorSelect={`#txtAccreditationNumber`}
                                                    place="top"
                                                    variant="error"
                                                    content="A valid accreditation id is required."
                                                />
                                            </div>
                                            ) : null
                                    }
                                </Form.Group>
                            </Stack>
                        </Col>
                    </Row>
                    <Row className='mb-3'>
                        <Col>
                            <Stack>
                                <div className="darkblue field-label">Initial Accreditation Date</div>
                                <DateTimePicker
                                    datetime={initialAccreditationDate}
                                    canwrite={true}
                                    isValid={validAccreditationDate}
                                    errorMessage={"An initial accreditation date at or before today is required"}
                                    showTime={false}
                                    showUTCTime={false}
                                    onChange={(date) => {
                                        setValidAccreditationDate(true);
                                        setInitialAccreditationDate(date);
                                    }}
                                    showHeadLabel={false}
                                />
                            </Stack>
                        </Col>
                    </Row>
                    <Row className='mb-3'>
                        <Col xs={6}>
                            <Stack>
                                <div className="darkblue field-label">Accreditation Status</div>
                                <Form.Group>
                                    <Form.Select value={accreditationStatus} onChange={(e) => setAccreditationStatus(e.target.value)}>
                                        <option value="true">Valid</option>
                                        <option value="false">Invalid</option>
                                    </Form.Select>
                                </Form.Group>
                            </Stack>
                        </Col>
                    </Row>
                    {
                        isEditMode === true ?
                            <Row>
                                <Col>
                                    <Stack direction='horizontal' gap={2}>
                                        <div className="darkblue field-label">Is Active</div>
                                        <Form.Group>
                                            <Form.Check
                                                onChange={(e) => {
                                                    setIsActive(e.target.checked);
                                                }}
                                                checked={isActive}
                                            />
                                        </Form.Group>
                                    </Stack>
                                </Col>
                            </Row>
                            : null
                    }
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Container>
                    {
                        showErrorMessage ?
                            <Row>
                                <Col>
                                    <Alert variant='danger'>{errorMessage}</Alert>
                                </Col>
                            </Row>
                            : null
                    }
                    {
                        showSuccessMessage ?
                            <Row>
                                <Col>
                                    <Alert variant='success'>{successText}</Alert>
                                </Col>
                            </Row>
                            : null
                    }
                    <Row>
                        <Col>
                            <Stack direction='horizontal' gap={3}>
                                <Button variant="primary" onClick={() => save()}>Save</Button>
                                { (managementUser && isActive) &&
                                    <Button variant="secondary" onClick={() => reinvite()}>Reinvite</Button>
                                }
                            </Stack>
                        </Col>
                    </Row>
                </Container>


            </Modal.Footer>
        </Modal>
    )
}

export default Accredited_Stockpersons_Add_Edit_Modal;